export default __webpack_public_path__ + "static/media/MISTER-EGO.de1371e5.png";